class BlogProgressBar extends HTMLElement {
  connectedCallback() {
    this.progressFill = this.querySelector(".blog-progress-bar__fill");
    if (!this.progressFill) return;

    this.onScrollOrResize = () => this.updateProgress();

    this.updateProgress();
    window.addEventListener("scroll", this.onScrollOrResize, { passive: true });
    window.addEventListener("resize", this.onScrollOrResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollOrResize);
    window.removeEventListener("resize", this.onScrollOrResize);
  }

  updateProgress() {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;

    const scrollable = scrollHeight - clientHeight;
    const percent = Math.min((scrollTop / scrollable) * 100, 100);

    if (this._lastPercent == percent) return;
    this.progressFill.style.width = `${percent}%`;
    this._lastPercent = percent;
  }
}

customElements.define("blog-progress-bar", BlogProgressBar);
